import AiNavigatorOutcomes from "./AiNavigatorOutcomes";

export default AiNavigatorOutcomes;